<template>
  <div v-if="currentUser && reportData" class="report-preview-page">
    <div class="page-header">
      <div>
        <h1>Szczegóły zgłoszenia</h1>
        <p>Podgląd zgłoszenia przesłanego przez użytkownika.</p>
      </div>

      <button class="btn-outline" @click="$router.push('/admin-profile/reports')">
        Wróć do listy
      </button>
    </div>

    <div class="layout">
      <section class="section-card details-card">
        <div class="section-card-header">
          <h2>Informacje o zgłoszeniu</h2>
          <span class="badge">{{ reportData.reportLabel }}</span>
        </div>

        <div class="info-section">
          <h3>Komentarz</h3>
          <p class="comment">
            {{ reportData.comment || 'Brak komentarza' }}
          </p>
        </div>

        <div class="info-section" v-if="sender">
          <h3>Zgłaszający</h3>

          <div class="info-list">
            <div class="info-row">
              <span class="info-label">Użytkownik</span>
              <span class="info-value">
                {{ sender.role.id === 3 ? 'prywatny' : 'biznesowy' }}
              </span>
            </div>

            <div class="info-row">
              <span class="info-label">E-mail</span>
              <span class="info-value">{{ sender.email }}</span>
            </div>

            <div class="info-row">
              <span class="info-label">Telefon</span>
              <span class="info-value" :class="{ muted: !sender.phone }">
                {{ sender.phone ? sender.phone : 'brak' }}
              </span>
            </div>
          </div>
        </div>

        <div class="info-section" v-else>
          <h3>Zgłaszający</h3>
          <p class="muted">Ładowanie danych zgłaszającego...</p>
        </div>
      </section>

      <section class="section-card reported-item-card">
        <div class="section-card-header">
          <h2>Zgłoszony element</h2>
          <span class="badge badge--orange">{{ reportData.reportLabel }}</span>
        </div>

        <ServiceModal />

        <div v-if="reportItemData" class="reported-item-preview">
          <AnnouncementCardVue
              :show-active="true"
              v-if="reportData.announcement_id"
              :key="reportItemData.id"
              :contact="reportItemData.contact"
              :target="reportItemData.target"
              :category="reportItemData.category"
              :img="reportItemData.photo_url"
              :longContent="reportItemData.description"
              :id="reportItemData.id"
              :title="reportItemData.title"
              :content="reportItemData.short_description"
              :photo="reportItemData.photo"
              :active="reportItemData.active"
          />

          <ServiceCardVue
              v-if="reportData.service_id"
              @openServiceModal="() => $router.push({ path: `/admin-profile/reports/${reportData.id}`, query: { serviceID: reportItemData.id } })"
              :price="reportItemData.price"
              :key="reportItemData.id"
              :is-advance="!!reportItemData.advanceAmount"
              :img="reportItemData.photo_url"
              :name="reportItemData.name"
              :state="states.filter(state => state.value === reportItemData.state_id)[0].name"
              :ishighlighted="reportItemData.active"
              :should-show-action-button="false"
          />
        </div>

        <div v-else class="empty-state">
          <h3>Ładowanie elementu</h3>
          <p>Trwa pobieranie danych zgłoszonego elementu.</p>
        </div>
      </section>
    </div>
  </div>

  <div v-else class="loading-state">
    <section class="section-card">
      <h2>Ładowanie szczegółów zgłoszenia...</h2>
    </section>
  </div>
</template>

<script>
import AnnouncementCardVue from '@/components/SpecialComponents/AnnouncementCard.vue';
import ServiceCardVue from '@/components/SpecialComponents/ServiceCard.vue';
import ServiceModal from '@/components/SpecialComponents/ServiceModal.vue';
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'AdminReportPreview',
  setup() {
    return {
      authStore: useAuthStore()
    };
  },
  data() {
    return {
      reportData: null,
      reportItemData: null,
      states: [],
      categories: [],
      sender: null
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }

    this.getReportData();
    this.getStates();
    this.getCategories();
  },
  methods: {
    getReportData() {
      axios.get(`/Report/${this.$route.params.reportId}`, authHeader()).then(res => {
        this.reportData = res.data;

        if (res.data.announcement_id) {
          this.reportData.reportItemId = res.data.announcement_id;
          this.reportData.reportUrl = `/Announcement`;
          this.reportData.reportLabel = `Ogłoszenie`;
        } else {
          this.reportData.reportItemId = res.data.service_id;
          this.reportData.reportUrl = `/Service`;
          this.reportData.reportLabel = `Usługa`;
        }
      }).then(() => {
        axios.get(`${this.reportData.reportUrl}/${this.reportData.reportItemId}`).then(res => {
          this.reportItemData = res.data;
        });
      }).then(() => {
        axios.get(`/User/${this.reportData.sender_id}`).then(res => {
          this.sender = res.data;
        });
      }).catch(() => {});
    },
    getStates() {
      axios.get('/State').then(res => {
        res.data.forEach((item) => {
          const ob = {
            name: item.name,
            value: `${item.id}`
          };
          this.states.push(ob);
        });
      });
    },
    getCategories() {
      axios.get('/Categories').then(res => {
        res.data.forEach((item) => {
          const ob = {
            name: item.name,
            id: `${item.id}`
          };
          this.categories.push(ob);
        });
      });
    }
  },
  components: { AnnouncementCardVue, ServiceCardVue, ServiceModal }
};
</script>

<style scoped lang="scss">
.report-preview-page {
  background: #ffffff;
  min-height: 100vh;
  padding: 24px 16px 32px;
  color: #1f2937;
}

.page-header {
  max-width: 1200px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 14px;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
}

.page-header p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 1.4rem;
  line-height: 1.5;
}

.layout {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.section-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 16px;
  box-sizing: border-box;
}

.details-card {
  width: 360px;
  flex-shrink: 0;
}

.reported-item-card {
  flex: 1 1 0;
  min-width: 0;
}

.section-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.section-card-header h2 {
  margin: 0;
  color: #1f2937;
  font-size: 2rem;
  font-weight: 700;
}

.badge {
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 1.2rem;
  font-weight: 700;
  white-space: nowrap;
}

.badge--orange {
  background: #fff7ed;
  color: #9a3412;
  border-color: #fed7aa;
}

.info-section {
  padding: 14px 0;
  border-bottom: 1px solid #e5e7eb;
}

.info-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.info-section h3 {
  margin: 0 0 8px;
  color: #1f2937;
  font-size: 1.6rem;
  font-weight: 700;
}

.comment {
  margin: 0;
  color: #374151;
  font-size: 1.4rem;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
}

.info-label {
  color: #6b7280;
  font-size: 1.2rem;
  font-weight: 600;
}

.info-value {
  color: #1f2937;
  font-size: 1.4rem;
  word-break: break-word;
}

.muted {
  color: #9ca3af;
}

.reported-item-preview {
  display: flex;
  justify-content: center;
  padding: 8px 0 0;
}

.empty-state {
  min-height: 180px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  background: #f9fafb;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
}

.empty-state h3 {
  margin: 0;
  font-size: 1.8rem;
}

.empty-state p {
  margin: 0;
  max-width: 480px;
  color: #6b7280;
  font-size: 1.35rem;
  line-height: 1.5;
}

.btn-outline {
  background: #ffffff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 1.35rem;
  cursor: pointer;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.loading-state {
  max-width: 800px;
  margin: 24px auto;
  padding: 0 16px;
  text-align: center;
  color: #1f2937;
}

.loading-state h2 {
  margin: 0;
  font-size: 2rem;
}

@media (max-width: 980px) {
  .layout {
    flex-direction: column;
  }

  .details-card,
  .reported-item-card {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .report-preview-page {
    padding: 16px 12px 24px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 14px 12px;
  }

  .section-card-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .section-card-header h2 {
    font-size: 1.8rem;
  }

  .btn-outline {
    width: 100%;
    text-align: center;
  }
}
</style>